
import {BehaviorSubject, Observable} from "rxjs";
import {Item} from "../../models/Item";
import {ConcreteHierarchyItemInterface} from "../concreteLayers/ConcreteHierarchyItemInterface";

export interface GroupConfig {
  id: number,
  title: string,
  parent_id: number | string,
  items: Item[],
  fixed_layer_id: number | string,
  floorplan_id: number,
}

export class Group implements ConcreteHierarchyItemInterface{
  protected children: Map<string, ConcreteHierarchyItemInterface> = new Map<string, ConcreteHierarchyItemInterface>();
  protected childrenObservable: Observable<ConcreteHierarchyItemInterface[]>;
  protected childrenObservable$: BehaviorSubject<ConcreteHierarchyItemInterface[]> = new BehaviorSubject<ConcreteHierarchyItemInterface[]>([]);

  constructor(config?) {
    this.assign(config);

  }

  private id: number;
  private title: string;
  private parent_id: number | string;
  private from_object_category_id: number | string;
  private position: number | string;
  private for_tools: any[];
  public items: Item[] = [];
  private fixed_layer_id : number | string;
  private floorplan_id : number;
  private event_id : number;
  public is_empty: boolean = false;
  public was_changed: boolean;
  public subgroups: any[];
  private _labelsVisibility: boolean = true;
  private _objectsDrag: boolean = false;

  private assign(config?:any){
    this.id = config.hasOwnProperty('id') ? config.id : null;
    this.event_id = config.hasOwnProperty('event_id') ? config.event_id : window['EVENT_ID'];
    this.title = config.hasOwnProperty('title') ? config.title : null;
    this.parent_id = config.hasOwnProperty('parent_id') ? config.parent_id : null;
    this.from_object_category_id = null;
    // config.hasOwnProperty('from_object_category_id') ? config.from_object_category_id : null;
    this.position = config.hasOwnProperty('position') ? config.position : 100;
    this.for_tools = config.hasOwnProperty('for_tools') ? config.for_tools : null;
    this.items = config.hasOwnProperty('items') ? config.items : [];
    this.fixed_layer_id = config.hasOwnProperty('fixed_layer_id') ? config.fixed_layer_id : null;
    this.floorplan_id = config.hasOwnProperty('floorplan_id') ? config.floorplan_id : null;
    this.was_changed = config.hasOwnProperty('was_changed') ? config.was_changed : false;
  }

  public updateGroupParams(config){
    this.id = config.hasOwnProperty('id') ? config.id : null;
    this.title = config.hasOwnProperty('title') ? config.title : null;
    this.parent_id = config.hasOwnProperty('parent_id') ? config.parent_id : null;
    this.items = config.hasOwnProperty('items') ? config.items : [];
    this.fixed_layer_id = config.hasOwnProperty('fixed_layer_id') ? config.fixed_layer_id : null;
    this.floorplan_id = config.hasOwnProperty('floorplan_id') ? config.floorplan_id : null;
  }

  public getId(){
    return this.id;
  }

  getEventId(){
    return this.event_id;
  }

  public getFloorPlanId():number{
    return this.floorplan_id ? +this.floorplan_id : this.floorplan_id;
  }

  public setId(value){
    if (this.id && this.id >= 0){
      return;
    }
    this.id = value;
  }

  getCategoryId(){
    return this.from_object_category_id;
  }

  getItems(){
    return this.items;
  }

  set labelVisibility(val){
    this._labelsVisibility = val;
  }

  set objectsDrag(val){
    this._objectsDrag = val;
  }

  get objectsDrag(){
    return this._objectsDrag;
  }

  get labelVisibility(){
    return this._labelsVisibility;
  }

  public asSimpleObject() : Object {
    let currentJson = this.asJSON();
    return JSON.parse(currentJson);
  }

  public asJSON(isKeepItems?) {
    return JSON.stringify(this, (k, v) => {
      if (k === 'childrenObservable') {
        return undefined;
      }
      if (k === 'childrenObservable$') {
        return undefined;
      }
      if (k === 'children') {
        return undefined;
      }
      if (k === 'items'){
        if (isKeepItems){
          return this.getItems().map((i)=>{
            return i.config.asJSON();
          })
        }
        return undefined;
      }
      return v;
    });
  }

  getGroupTools(){
    return this.for_tools;
  }

  addItem(item:Item){
    if (this.items.indexOf(item) < 0){
      this.items.push(item);
      item.config.setGroupId(this.getId());
      this.was_changed = true;
      console.log('was_changed 333333333')
    }
  }

  removeItem(item:Item){
    if (this.items.indexOf(item) >= 0){
      this.items.splice(this.items.indexOf(item), 1);
    }
  }

  public addChild(item: ConcreteHierarchyItemInterface): void {
    this.children.set(item.getCHIId(), item);
  }

  public removeChild(item: ConcreteHierarchyItemInterface): void {
    this.children.delete(item.getCHIId());
  }
  public getCHIId(): string {
    return "Groups-" + (this.getId() ? this.getId() : Math.random());
  }

  public getChildren(): Observable<ConcreteHierarchyItemInterface[]> {
    return this.childrenObservable$.asObservable();
  }

  public setChildren(observable: Observable<ConcreteHierarchyItemInterface[]>) {
    // this.childrenObservable = observable;
    observable.subscribe(d => this.childrenObservable$.next(d));
  }

  public getIconUrl(): string {
    return null;
  }

  getParentItemId(){
    return null;
  }

  getParentConcreteId(){
    return this.floorplan_id;
  };

  public getSort(): number {
    return 0;
  }

  public getTitle(): string {
    return this.title;
  }

  public setTitle(value:string){
    this.title = value
  }

  public onSelect(){}

  public getParentGroupId(){
    return this.parent_id;
  }

}
